
/**
 * Enum representing the supported model value categories.
 */
export enum EnumCategoryCodes {

  /**
   * The group of model values that are used to calculate the volume discount adjustment
   * within the deal header
   */
  VolumeDiscount = 'vol-disc-adj',

  /**
   * The group of model values that are used to calculate the cost totals for the deal header
   */
  CostTotals = 'cost-totals',

  /**
   * The cost/spend for annual results
   */
  CostResultsAnnual = 'acv',

  /**
   * The cost/spend for total results
   */
  CostResultsTotal = 'tcv',

  /**
   * The tower customer spend multi year 
   */
  CSpendTowerMultiYear = 'cs-raw',
}
